<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>AUTHOR’S NOTE</span></p>
<p class="normal">The publication of this third novel in the Drury Lane trilogy makes a brief word of explanation necessary.</p>
<p class="indent">The cases entitled <i>The Tragedy of X</i> and <i>The Tragedy of Y</i> occurred very close to each other in point of time. But <i>The Tragedy of Z</i> took ten years in the making. By that I mean that a full decade elapsed before a problem arose which made possible a title consistent with the titles of the first two.</p>
<p class="indent">In the intervening period Drury Lane solved many strange and perplexing cases, the most interesting of which will be recorded at some future time.</p>
<p class="righta"><span>E<span class="smallcaps">LLERY</span> Q<span class="smallcaps">UEEN</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?743ec256